import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTriangleUpMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChevronTriangleUpMedium"><Path d="M12 6.4375L4.86523 15H19.1348L12 6.4375Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronTriangleUpMedium;
